import  { useState } from "react";
import { FaUser } from "react-icons/fa";
// import { IoCloseOutline } from "react-icons/io5";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import api from "../../../utils/redux/api";
import { Box, Typography } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import axiosServicesOnboarding from "../../../services/axiosServicesOnboarding";

const StepBox = ({ number, title }) => {
  return (
    <Box position="relative">
      <Box
        display="flex"
        alignItems="center"
        border="1px solid #e0e0e0"
        borderRadius="8px"
        padding="6px"
        bgcolor="#ffffff"
        position="relative"
      >
        {/* Number Circle */}
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          width="40px"
          height="40px"
          border="2px solid #001d7e"
          borderRadius="50%"
          marginRight="8px"
        >
          <Typography variant="body1" color="#001d7e" fontWeight="bold">
            {number}
          </Typography>
        </Box>

        {/* Title */}
        <Typography variant="body1" fontWeight="bold" color="#001d7e">
          {title}
        </Typography>

        {/* Pointed edge - border */}
        <Box
          position="absolute"
          right="-21px"
          top="50%"
          sx={{
            transform: "translateY(-50%)",
            borderLeft: "21px solid #e0e0e0",
            borderTop: "21px solid transparent",
            borderBottom: "21px solid transparent",
          }}
        />

        {/* Pointed edge - fill */}
        <Box
          position="absolute"
          right="-20px"
          top="50%"
          sx={{
            transform: "translateY(-50%)",
            borderLeft: "20px solid #ffffff",
            borderTop: "20px solid transparent",
            borderBottom: "20px solid transparent",
            zIndex: 1,
            height: "60px",
          }}
        />
      </Box>
    </Box>
  );
};

const SetPinVerification = ({ onBack, refresh, setRefresh }) => {
  const [showPin, setShowPin] = useState(false);
  const [showConfirmPin, setShowConfirmPin] = useState(false);

  const toggleShowPin = () => {
    setShowPin(!showPin);
  };
  const toggleShowConfirmPin = () => {
    setShowConfirmPin(!showConfirmPin);
  };

  const validationSchema = Yup.object({
    pin: Yup.string()
      .matches(/^[0-9]{4}$/, "PIN must be exactly 4 digits")
      .required("PIN is required"),
    confirmPin: Yup.string()
      .oneOf([Yup.ref("pin"), null], "PINs do not match")
      .required("Confirm PIN is required"),
  });

  return (
    <div className="w-full md:w-[650px] mx-auto p-4">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center space-x-2 text-gray-700 text-lg font-semibold">
          <FaUser className="text-xl text-primary-color" />
          <span>Set PIN</span>
        </div>
        <button onClick={onBack} className="text-gray-600 text-2xl">
          {/* <IoCloseOutline /> */}
          <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M16.0003 29.3337C23.3641 29.3337 29.3337 23.3641 29.3337 16.0003C29.3337 8.63653 23.3641 2.66699 16.0003 2.66699C8.63653 2.66699 2.66699 8.63653 2.66699 16.0003C2.66699 23.3641 8.63653 29.3337 16.0003 29.3337Z"
              stroke="#25233A"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M20 12L12 20"
              stroke="#25233A"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M12 12L20 20"
              stroke="#25233A"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
      </div>

      <div className="px-8 py-1 bg-[#edf1f9] rounded-md mb-8">
        <Box maxWidth="600px" width="100%" p={2}>
          <StepBox number="05" title="Set Transaction PIN" />
        </Box>
      </div>

      <h3 className="text-lg font-semibold text-primary-color text-center mb-6">
        Enter 4-digit Transaction PIN
      </h3>

      <Formik
        initialValues={{ pin: "", confirmPin: "" }}
        validationSchema={validationSchema}
        onSubmit={async (values, { setSubmitting }) => {
          const payload = { pin: values.pin };
          try {
            setSubmitting(true);
            const response = await axiosServicesOnboarding.post(
              "customer/create-pin",
              payload
            );
            console.log("Response", response);
            if (response?.status === true) {
              toast.success("PIN added successfully");
              setSubmitting(false);
              setRefresh(!refresh);
            } else {
              console.log(response);
              toast.error(response?.payload?.data?.message || "Error occurred");
              setSubmitting(false);
            }
          } catch (error) {
            // handleError(error);
            console.error("API error:", error?.response?.data?.message);
            toast.error(error?.response?.data?.message);
            setSubmitting(false);
          }
        }}
      >
        {({ isSubmitting }) => (
          <Form className="space-y-6 w-full md:w-[400px] mx-auto">
            <div>
              <label className="block text-gray-600 font-medium mb-2">
                Enter PIN <span className="text-red-500">*</span>
              </label>
              <Field
                type={showPin ? "text" : "password"}
                name="pin"
                placeholder="****"
                className="w-full p-3 border border-gray-300 rounded-md"
              />
              <span className="relative">
                {showPin ? (
                  <Visibility
                  className="absolute right-3 top-[10px] -translate-y-1/2 cursor-pointer text-gray-500 hover:text-gray-700"
                    onClick={toggleShowPin}
                    sx={{ color: "black" }}
                  />
                ) : (
                  <VisibilityOff
                  className="absolute right-3 top-[10px] -translate-y-1/2 cursor-pointer text-gray-500 hover:text-gray-700"
                  onClick={toggleShowPin}
                    sx={{ color: "black" }}
                  />
                )}
              </span>
              <ErrorMessage
                name="pin"
                component="div"
                className="text-red-500 text-sm mt-1"
              />
            </div>

            <div>
              <label className="block text-gray-600 font-medium mb-2">
                Confirm PIN <span className="text-red-500">*</span>
              </label>
              <Field
                type={showConfirmPin ? "text" : "password"}
                name="confirmPin"
                placeholder="****"
                className="w-full p-3 border border-gray-300 rounded-md"
              />
               <span className="relative">
                {showConfirmPin ? (
                  <Visibility
                  className="absolute right-3 top-[10px] -translate-y-1/2 cursor-pointer text-gray-500 hover:text-gray-700"
                  onClick={toggleShowConfirmPin}
                    sx={{ color: "black" }}
                  />
                ) : (
                  <VisibilityOff
                  className="absolute right-3 top-[10px] -translate-y-1/2 cursor-pointer text-gray-500 hover:text-gray-700"
                  onClick={toggleShowConfirmPin}
                    sx={{ color: "black" }}
                  />
                )}
              </span>
              <ErrorMessage
                name="confirmPin"
                component="div"
                className="text-red-500 text-sm mt-1"
              />
            </div>

            <button
              type="submit"
              disabled={isSubmitting}
              className={`w-full ${
                isSubmitting
                  ? "bg-gray-400 cursor-not-allowed"
                  : "bg-primary-color hover:bg-[#8388B6]"
              } text-white font-semibold py-4 px-6 rounded-md`}
            >
              {isSubmitting ? "Submitting..." : "Create"}
            </button>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default SetPinVerification;
